import { render, staticRenderFns } from "./FolderCard.vue?vue&type=template&id=22d78471&scoped=true"
import script from "./FolderCard.vue?vue&type=script&lang=js"
export * from "./FolderCard.vue?vue&type=script&lang=js"
import style0 from "./FolderCard.vue?vue&type=style&index=0&id=22d78471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d78471",
  null
  
)

export default component.exports